import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';
import getSocketMiddlewareInstance from '../../common/SocketMiddleware';

const apiCaller = getApiInstance();

export function getProducts(env) {
    return dispatch => {
        return apiCaller
            .call(api.getAllProducts(env))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__SET_PRODUCTS`,
                        products: data.products,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setProducts - ', error);
                throw error;
            });
    };
}
export function getProductsDetails(env, homeId, productType, productIdentifier) {
    return dispatch => {
        return apiCaller
            .call(api.getProductsDetails(env, homeId, productType, productIdentifier))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__SET_PRODUCT_DETAILS`,
                        product: data.productDetails,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setProductsDetails - ', error);
                throw error;
            });
    };
}

export function getProductsByHomeId(env, homeId) {
    return dispatch => {
        return apiCaller
            .call(api.getProductsByHomeId(env, homeId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_HOME_PRODUCTS`,
                        products: data.products,
                        homeId,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setProducts - ', error);
                throw error;
            });
    };
}
export function getStatsProducts(env, homeId) {
    return () => {
        return apiCaller
            .call(api.getStatsProducts(env, homeId))
            .then(({ data }) => {
                if (data.success) {
                    return data.homeProducts;
                }
            })
            .catch(error => {
                Logger.log('dataActions: setProducts - ', error);
                throw error;
            });
    };
}
export function getStatsProductsConsoProd(env, homeId, fromDate, product_identifier, code) {
    return () => {
        return apiCaller
            .call(api.getStatsProductsConsoProd(env, homeId, fromDate, product_identifier, code))
            .then(({ data }) => {
                if (data.success) {
                    return data.productEnergy;
                }
            })
            .catch(error => {
                Logger.log('dataActions: setProducts - ', error);
                throw error;
            });
    };
}
export function getProductsConsoProd(env, homeId) {
    return () => {
        return apiCaller
            .call(api.getProductsConsoProd(env, homeId))
            .then(({ data }) => {
                if (data.success) {
                    console.log(data.statsProductsConsoProd, 'bliblu')
                    return data.statsProductsConsoProd;
                }
            })
            .catch(error => {
                Logger.log('dataActions: setProducts - ', error);
                throw error;
            });
    };
}
export function updateProductModuleLabel(env, fheCenter_mac, product_identifier, product_type, module_type, code, label) {
    return () => {
        return getSocketMiddlewareInstance()
            .updateProductModuleLabel(fheCenter_mac, product_identifier, product_type, module_type, code, label)
            .catch(error => {
                Logger.log('dataActions: updateProductModuleMiddleware - ', error);
                throw error;
            });
    };
}

export function updateSDM20LHTConfig(env, fheCenter_mac, homeId, productType, product_identifier, typeDiversity, output) {
    return dispatch => {
        return getSocketMiddlewareInstance()
            .updateSDM20LHTConfig(fheCenter_mac, product_identifier, typeDiversity, output)
            .then(() => {
                return apiCaller
                    .call(api.getProductsDetails(env, homeId, productType, product_identifier))
                    .then(({ data }) => {
                        if (data.success) {
                            dispatch({
                                type: `${env.toUpperCase()}__SET_PRODUCT_DETAILS`,
                                product: data.productDetails,
                            });
                        }
                        return data;
                    })
                    .catch(error => {
                        Logger.log('dataActions: setProductsDetails - ', error);
                        throw error;
                    });
            })
            .catch(error => {
                Logger.log('dataActions: updateProductModuleMiddleware - ', error);
                throw error;
            });
    };
}

export function refreshProductStatus(env, fheCenter_mac, productType, productKey, moduleType) {
    return () => {
        return getSocketMiddlewareInstance()
            .productCheckStatus(fheCenter_mac, productType, productKey, moduleType)
            .catch(error => {
                Logger.log('dataActions: refreshProductStatus - ', error);
                throw error;
            });
    };
}

export function inelioGetAllParamsAction(payload) {
    return () => {
        return getSocketMiddlewareInstance()
            .inelioGetAllParams(payload)
            .catch(error => {
                Logger.log('dataActions: inelioGetAllParamsAction - ', error);
                throw error;
            });
    };
}

export function inelioSetParamAction(payload) {
    return () => {
        return getSocketMiddlewareInstance()
            .inelioSetParam(payload)
            .catch(error => {
                Logger.log('dataActions: inelioSetParamAction - ', error);
                throw error;
            });
    };
}

export function inelioSetDiagModeAction(payload) {
    return getSocketMiddlewareInstance()
        .inelioSetDiagMode(payload)
        .catch(error => {
            Logger.log('dataActions: inelioSetDiagMode  - ', error);
            throw error;
        });
}

export function inelioClearAlarmAction(payload) {
    return getSocketMiddlewareInstance()
        .inelioClearAlarm(payload)
        .catch(error => {
            Logger.log('dataActions: inelioAlarmACK  - ', error);
            throw error;
        });
}

export function inelioSetSlaveActuatorAction(payload) {
    return getSocketMiddlewareInstance()
        .inelioSetSlaveActuator(payload)
        .catch(error => {
            Logger.log('dataActions: inelioSetSlaveActuator  - ', error);
            throw error;
        });
}

export function inelioSetStageActuatorAction(payload) {
    return getSocketMiddlewareInstance()
        .inelioSetStageActuator(payload)
        .catch(error => {
            Logger.log('dataActions: inelioSetStageActuator  - ', error);
            throw error;
        });
}

export function updateProductField(env, fieldName, homeId, identifier, type, fieldValue, moduleType) {
    let key = `${homeId}_${type}_${identifier}`;
    return dispatch => {
        return apiCaller
            .call(api.updateProductField(env, fieldName, homeId, identifier, type, fieldValue, moduleType))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__PRODUCT_UPDATE_FIELD`,
                        productKey: key,
                        fieldName: fieldName,
                        fieldValue: fieldValue,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: updateProductField - ', error);
                throw error;
            });
    };
}

export function dissociateProduct(env, fieldName, homeId, identifier, type, fieldValue, moduleType) {
    let key = `${homeId}_${type}_${identifier}`;
    return dispatch => {
        return apiCaller
            .call(api.dissociateProduct(env, fieldName, homeId, identifier, type, fieldValue, moduleType))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__PRODUCT_DISSOCIATE`,
                        productKey: key,
                        fieldName: fieldName,
                        fieldValue: fieldValue,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: dissociateProduct - ', error);
                throw error;
            });
    };
}

export function updateProductModule(env, homeId, identifier, productType, code, form, type, lineType) {
    let productKey = `${homeId}_${productType}_${identifier}`;
    let productModuleKey = `${productType}_${identifier}_${code}`;
    return dispatch => {
        return apiCaller
            .call(api.updateProductModule(env, homeId, identifier, productType, code, form, type, lineType))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__PRODUCT_MODULE_UPDATE`,
                        productKey: productKey,
                        productModuleKey: productModuleKey,
                        form: form,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: updateProductModule - ', error);
                throw error;
            });
    };
}

export function connectToAP(env, fheCenter_mac, product_identifier) {
    return () => {
        return getSocketMiddlewareInstance()
            .connectToAP(fheCenter_mac, product_identifier)
            .catch(error => {
                Logger.log('dataActions: connectToAP - ', error);
                throw error;
            });
    };
}

export function getWifiList(env, fheCenter_mac) {
    return () => {
        return getSocketMiddlewareInstance()
            .getWifiList(fheCenter_mac)
            .catch(error => {
                Logger.log('dataActions: getWifiList - ', error);
                throw error;
            });
    };
}

export function startProductInclusion(env, fheCenter_mac, product_identifier, ssid, password, encryption, encryption_type, step_callback) {
    return () => {
        return getSocketMiddlewareInstance()
            .startProductInclusion(fheCenter_mac, product_identifier, ssid, password, encryption, encryption_type, step_callback)
            .catch(error => {
                Logger.log('dataActions: startProductInclusion - ', error);
                throw error;
            });
    };
}

export function getAPWifiProductsList(env, fheCenterMac) {
    return () => {
        return getSocketMiddlewareInstance()
            .getAPWifiProductsList(fheCenterMac)
            .catch(error => {
                Logger.log('dataActions: getAPWifiProductList - ', error);
                throw error;
            });
    };
}

export function updateThreshold(env, fheCenter_mac, product_identifier, module_type, code, threshold) {
    return () => {
        return getSocketMiddlewareInstance()
            .updateThreshold(fheCenter_mac, product_identifier, module_type, code, threshold)
            .catch(error => {
                Logger.log('dataActions: UpdateThresholdProductModule - ', error);
                throw error;
            });
    };
}

export function updateGain(env, fheCenter_mac, product_identifier, module_type, code, gain) {
    return () => {
        return getSocketMiddlewareInstance()
            .updateGain(fheCenter_mac, product_identifier, module_type, code, gain)
            .catch(error => {
                Logger.log('dataActions: UpdateGainProductModule - ', error);
                throw error;
            });
    };
}

export function updateReversePolarity(env, fheCenter_mac, product_identifier, module_type, code, reversePolarity) {
    return () => {
        return getSocketMiddlewareInstance()
            .updatePolarity(fheCenter_mac, product_identifier, module_type, code, reversePolarity)
            .catch(error => {
                Logger.log('dataActions: UpdateReversePolarityProductModule - ', error);
                throw error;
            });
    };
}

export function resetRelaysInversions(env, fheCenter_mac, product_identifier, module_type) {
    return () => {
        return getSocketMiddlewareInstance()
            .resetRelaysInversions(fheCenter_mac, product_identifier, module_type)
            .catch(error => {
                Logger.log('dataActions: FheResetRelaysInversionsProductModule - ', error);
                throw error;
            });
    };
}
export function startMMBScan(env, product_identifier) {
    return () => {
        return getSocketMiddlewareInstance()
            .startMMBScan(product_identifier)
            .catch(error => {
                Logger.log('dataActions: FheStartMMBScanProductModule - ', error);
                throw error;
            });
    };
}

export function deleteProduct(env, homeId, productType, productIdentifier, type) {
    return dispatch => {
        return apiCaller
            .call(api.deleteProduct(env, homeId, productType, productIdentifier, type))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__PRODUCT_DELETE`,
                        productKey: `${homeId}_${productType}_${productIdentifier}`,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: deleteProduct - ', error);
                throw error;
            });
    };
}



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Products/actions.js